/** @jsxImportSource @emotion/react */
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/react'
import React from 'react'

import { Col } from '../../packages/kiti/components/structure/Grid'
import Panel from '../../packages/kiti/components/structure/Panel'
import Icon from '../../packages/kiti/components/shapes/Icon'
import Separator from '../../packages/kiti/components/helpers/Separator'
import Text from '../../packages/kiti/components/presentation/Text'
import { useOpenEditProcessModal } from '../../utils/routes/modals/modalsActions'
import { useProcesses } from './_load/ProcessesListLoader'
import ProcessesItem from './ProcessesItem'

const ProcessGridWrapper = ({ children }) => {
  const style = css`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(min(240px, 100%), 1fr));
    gap: 1rem;
  `
  return <div css={style}>{children}</div>
}

const ProcessesGrid = () => {
  const processes = useProcesses()
  const canCreateScreen = useSessionPermission('setupScreen')
  const openEditProcess = useOpenEditProcessModal()
  const { t } = useTranslation('processes')

  return (
    <ProcessGridWrapper>
      {canCreateScreen && (
        <Col>
          <Panel borderStyle="dashed" align="center" justify="center" height={14} onClick={() => openEditProcess({})}>
            <Icon name="BsPlusSquareDotted" color="dark3" />
            <Separator weight={2} />
            <Text bold color="dark3">
              {t('processes.newProcess')}
            </Text>
          </Panel>
        </Col>
      )}

      {processes.map(screen => (
        <ProcessesItem key={screen.id} screen={screen} />
      ))}
    </ProcessGridWrapper>
  )
}

export default ProcessesGrid
